import { PAGE_SIZES } from '../../constants'
import { PAGINATION_SAGA_SET_NUMBER, PAGINATION_SAGA_SET_SIZE, PAGINATION_SET_PAGINATION } from '../actionTypes'

const setPaginationNumber = number => ({ type: PAGINATION_SAGA_SET_NUMBER, number })
const setPaginationSize = max => ({ type: PAGINATION_SAGA_SET_SIZE, max })

export const setPagination = pages => ({
    type: PAGINATION_SET_PAGINATION,
    size: PAGE_SIZES.SHIFTS.LIST_VIEW,
    pages,
})

export {
    setPaginationNumber,
    setPaginationSize,
}
